import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import api from "@/lib/api";

const FALLBACK = {
  about: { title: "About Noventra Academic Press", subtitle: "Open Access Peer-Reviewed International Journals", body: "" },
  "for-authors": { title: "Publish With Noventra", subtitle: "Rigorous, rapid and transparent open-access publishing.", body: "" },
  "for-reviewers": { title: "Join Our Reviewer Community", subtitle: "Peer reviewers are the backbone of scholarly publishing.", body: "" },
  "peer-review": { title: "Peer Review Process", subtitle: "How every manuscript is evaluated before publication.", body: "" },
  "open-access": { title: "Open Access Policy", subtitle: "Free, immediate and permanent access to published research.", body: "" },
  "publication-ethics": { title: "Publication Ethics", subtitle: "Our commitment to integrity in scholarly publishing.", body: "" },
};

export function usePageContent(slug) {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get(`/pages/${slug}`).then(({ data }) => setContent(data)).catch(() => setContent(FALLBACK[slug] || { title: "", subtitle: "", body: "" }));
  }, [slug]);
  return content;
}

// Renders either HTML (from the rich editor) or legacy plain-text bodies.
export function Paragraphs({ text, className = "" }) {
  if (!text) return null;
  const isHtml = /<[a-z][\s\S]*>/i.test(text);
  const html = isHtml
    ? text
    : text.split(/\n\n+/).map((p) => `<p>${p.replace(/</g, "&lt;")}</p>`).join("");
  const clean = DOMPurify.sanitize(html, { ADD_ATTR: ["target", "rel"] });
  return <div className={`rich-content ${className}`} dangerouslySetInnerHTML={{ __html: clean }} />;
}
